import { api } from "@/services/api"

export const resendInvite = async (userId: string) => {
  await api.post(
    `/beepaidgo/users/${userId}/resend-invite/`
  )
}
